import { useState, useEffect } from 'react';
import LocationsService from '../../../services/LocationsService';
import notify from '../../../utils/notifier';
import { Grid, MenuItem, Select, FormControl, InputLabel, Checkbox, FormControlLabel, Typography, Button} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useCompany } from '../../../CompanyContext';


export const columns = [
  { id: 'id', label: 'Id',width: '10%' },
  { id: 'placeName', label: 'Place Name',width: '10%', sortable: true },
  { id: 'unlocode', label: 'Unlocode',width: '10%'},
  { id: 'zipCode', label: 'Zip Code',width: '10%', sortable: false  },
  { id: 'city', label: 'City' ,width: '10%', sortable: true },
  { id: 'state', label: 'State',width: '10%', sortable: true },
  { id: 'country', label: 'Country',width: '10%', sortable: true },
  { id: 'code', label: 'Code',width: '10%', sortable: false },
  { id: 'type', label: 'Type',width: '10%', sortable: false },
  { id: 'isActive', label: 'Active',width: '10%' },
  { id: 'isVerified', label: 'Verified',width: '10%' },
  { id: 'iataCode', label: 'IATA Code' ,width: '10%'},
  { id: 'locode', label: 'Locode' ,width: '10%'},
  { id: 'locality', label: 'Locality',width: '10%'},
  { id: 'latitude', label: 'Latitude',width: '10%' },
  { id: 'longitude', label: 'Longitude' ,width: '10%'},
  { id: 'actions', label: 'Actions',width: '10%' }
];



export const manageColumns = {
  id: true,
  placeName: true,
  unlocode:true,
  zipCode: true,
  city: true,
  state: true,
  country: true,
  code:true,
  type:true,
  isVerified:true,
  isActive:true,
  iataCode: false,
  locode: false,
  locality: false,
  latitude: false,
  longitude: false
};

export const Locations = () => {
  const { overallCompany } = useCompany(); 
  let _defaultApplicationNamespace = localStorage.getItem('_defaultApplicationNamespace');
  let _locationTypes = JSON.parse(localStorage.getItem('_locationTypes'));
  const [defaultApplicationNamespace, setDefaultApplicationNamespace ] = useState(_defaultApplicationNamespace);
  const defaultFilters = {
    city: '',
    state: '',
    country: '',
    state_code: '',
    country_code: '',
    is_active: ['true'],
    is_verified: ['true', 'false'],
    type:[],
    unlocode: '',
    application_namespace: _defaultApplicationNamespace
  };

  const [applicationNamespaces, setApplicationNamespaces] = useState(JSON.parse(localStorage.getItem('_applicationNamespaces')));
  const [applicationNamespaceLocationTypes, setApplicationNamespaceLocationTypes] = useState(_locationTypes);
  const [locationsFilterValues, setLocationsFilterValues] = useState(defaultFilters);
  const [backdrop, setBackdrop] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [stateCodes, setStateCodes] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);
  const [locationTypes, setLocationTypes] = useState(_locationTypes[_defaultApplicationNamespace])
  // Fetch countries data on mount
  useEffect(() => {
    if (!countries.length) {
      getCountriesData();
    }
  }, [countries]);

  // Fetch states and cities when the country filter changes
  useEffect(() => {
    if (locationsFilterValues.country) {
      getStatesData(locationsFilterValues.country);
      getCitiesData(locationsFilterValues.country);
    }
  }, [locationsFilterValues.country, countries]);

  // Fetch cities when the state filter changes
  useEffect(() => {
    if (locationsFilterValues.state) {
      getCitiesData(locationsFilterValues.country, locationsFilterValues.state);
    }
  }, [locationsFilterValues.state, states]);

  useEffect(()=>{
    let _defaultApplicationNamespace = localStorage.getItem('_defaultApplicationNamespace');
    let _locationTypes = JSON.parse(localStorage.getItem('_locationTypes'));
    setDefaultApplicationNamespace(_defaultApplicationNamespace);
    setApplicationNamespaces(JSON.parse(localStorage.getItem('_applicationNamespaces')));
    setApplicationNamespaceLocationTypes(_locationTypes);
    setLocationsFilterValues({
      city: '',
      state: '',
      country: '',
      state_code: '',
      country_code: '',
      is_active: ['true'],
      is_verified: ['true', 'false'],
      type:[],
      unlocode: '',
      application_namespace: _defaultApplicationNamespace
    });
    setBackdrop(false);
    setCountries([]);
    setStates([]);
    setCities([]);
    setStateCodes([]);
    setCountryCodes([]);
    setLocationTypes(_locationTypes[_defaultApplicationNamespace]);
  }, [overallCompany]);

  

  // Function to clear the filters
  const handleLocationsFilterClear = (forQuerySearch=false) => {
    setStates([]);
    setCities([]);
    setStateCodes([]);
    setLocationTypes(applicationNamespaceLocationTypes[defaultApplicationNamespace]);
    const defaultFiltersForQuery = {
      city: '',
      state: '',
      country: '',
      state_code: '',
      country_code: '',
      type:[],
      unlocode: '',
      is_active: locationsFilterValues.is_active || ['true'],
      is_verified: locationsFilterValues.is_verified || ['true'],
      application_namespace: locationsFilterValues.application_namespace || defaultApplicationNamespace,
    };
    if(forQuerySearch){
      setLocationsFilterValues(defaultFiltersForQuery);
    }else{
      setLocationsFilterValues({
        city: '',
        state: '',
        country: '',
        state_code: '',
        country_code: '',
        is_active: ['true'],
        is_verified: ['true', 'false'],
        type:[],
        unlocode: '',
        application_namespace: defaultApplicationNamespace
      });
    }
  };

  // Function to apply the filters
  const getLocationFilters = (filters) => {
    if (locationsFilterValues.city) {
      const city = cities.find(
        city =>
          city.name === locationsFilterValues.city &&
          city.countryIso2 === locationsFilterValues.country_code
      );
      filters['_cityId'] = city.id;
      delete filters._countryId;
      delete filters._stateId;
    } else if (locationsFilterValues.state) {
      const state = states.find(
        state =>
          state.name === locationsFilterValues.state &&
          state.countryIso2 === locationsFilterValues.country_code
      );
      filters['_stateId'] = state.id;
      delete filters._countryId;
    } else if (locationsFilterValues.country) {
      const country = countries.find(
        country =>
          country.name === locationsFilterValues.country &&
          country.iso2 === locationsFilterValues.country_code
      );
      filters['_countryId'] = country.id;
    } 
    if (locationsFilterValues.unlocode && locationsFilterValues.unlocode.length) {
      filters['_unlocode'] = locationsFilterValues.unlocode;
    } else{
      delete filters._unlocode
    }
    if (locationsFilterValues.type.length) {
      filters['_type'] = Array.isArray(locationsFilterValues.type)
      ? locationsFilterValues.type.join('|')
      : locationsFilterValues.type;
    } 

    if(locationsFilterValues.application_namespace){
      filters['_applicationNamespace'] = locationsFilterValues.application_namespace;
    }

    filters['_isActive'] = locationsFilterValues.is_active;
    filters['_isVerified'] = locationsFilterValues.is_verified;
    return filters;
  };

  // Function to fetch countries
  const getCountriesData = async () => {
    try {
      setBackdrop(true);
      const response = await LocationsService.getCountriesData();
      const countriesData = response.data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
      const countryCodesData = countriesData.map(x => x.iso2).sort();
      setCountries(countriesData);
      setCountryCodes(countryCodesData);
    } catch (error) {
      notify({ type: 'error', message: 'Error fetching countries data' });
    } finally {
      setBackdrop(false);
    }
  };

  // Function to fetch states based on country
  const getStatesData = async countryName => {
    try {
      const country = countries.find(country => country.name === countryName);
      const query = { _countryIso2: country.iso2 };
      setBackdrop(true);
      const response = await LocationsService.getStatesData(query);
      const statesData = response.data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });;
    
      setStates(statesData);
      setStateCodes(statesData.map(x => x.stateIso2));
    } catch (error) {
      notify({ type: 'error', message: 'Error fetching states data' });
    } finally {
      setBackdrop(false);
    }
  };

  // Function to fetch cities based on country and state
  const getCitiesData = async (countryName, stateName = '') => {
    try {
      const country = countries.find(country => country.name === countryName);
      const query = { _countryIso2: country.iso2 };
      if (stateName) {
        const state = states.find(state => state.name === stateName);
        query['_stateIso2'] = state.stateIso2;
      }
      setBackdrop(true);
      const response = await LocationsService.getCitiesData(query);
      response.data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });;
      setCities(response.data);
    } catch (error) {
      notify({ type: 'error', message: 'Error fetching cities data' });
    } finally {
      setBackdrop(false);
    }
  };

  const handleCountryFilterChange = event => {
    const { name, value } = event.target;
    const country = countries.find(country => country.name === value);
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value,
      country_code: country.iso2
    }));
    getStatesData(value);
    getCitiesData(value);
  };

  const handleStateFilterChange = event => {
    const { name, value } = event.target;
    const state = states.find(state => state.name === value);
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value,
      state_code: state.stateIso2 || ''
    }));
    if (!locationsFilterValues.city) {
      getCitiesData(locationsFilterValues.country, value);
    }
  };

  const handleCityFilterChange = event => {
    const { name, value } = event.target;
    if (!locationsFilterValues.state) {
      const selectedCity = cities.find(city => city.name === value);
      setLocationsFilterValues(prevValues => ({
        ...prevValues,
        [name]: value,
        state: selectedCity ? selectedCity.stateName : prevValues.state,
        state_code: selectedCity ? selectedCity.stateIso2 : prevValues.state_code,
        country: selectedCity ? selectedCity.countryName : prevValues.country,
        country_code: selectedCity ? selectedCity.countryIso2 : prevValues.country_code
      }));
    } else {
      setLocationsFilterValues(prevValues => ({
        ...prevValues,
        [name]: value
      }));
    }
  };

  const handleCountryCodeFilterChange = event => {
    const { name, value } = event.target;
    const country = countries.find(country => country.iso2 === value);
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value,
      country: country.name || ''
    }));
    getStatesData(country.name);
    getCitiesData(country.name);
  };

  const handleUnlocodeFilterChange = event => {
    const { name, value } = event.target;
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleApplicationNamespaceFilterChange = event => {
    const { name, value } = event.target;
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));
    setLocationTypes(applicationNamespaceLocationTypes[value])
  };

  const handleStateCodeFilterChange = event => {
    const { name, value } = event.target;
    const state = states.find(state => state.stateIso2 === value);
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value,
      state: state.name || ''
    }));
    getCitiesData(locationsFilterValues.country, state.name);
  };

  const handleTypeFilterChange = event => {
    const { name, value } = event.target;
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value
    }));
  };

  const handleActiveFilterChange = event => {
    const { name, value } = event.target;
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value
    }));
  };

  const handleVerifiedFilterChange = event => {
    const { name, value } = event.target;
    setLocationsFilterValues(prevValues => ({
      ...prevValues,
      [name]: value
    }));
  };

  const downloadLocationsData = async query => {
    try {
      if(query._isActive && query._isActive.includes('true') && query._isActive.includes('false')){
        delete query._isActive
      } else {
        // ths condition in this way because if query._isActive comes as undefined also 
        // we are setting it as a true which is our default value of _isActive filter
        query._isActive = (query._isActive && query._isActive.includes('false')) ? false : true
      }
      if(query._isVerified.includes('true') && query._isVerified.includes('false')){
        delete query._isVerified
      } else if(query._isVerified){
        // ths condition in this way because if query._isVerified comes as undefined also 
        // we are setting it as a true which is our default value of _isVerified filter
        query._isVerified = (query._isVerified.includes('false')) ? false : true
      }
      
      if(query._format === undefined || !query._format){
        query._format = 'CSV'
      }
      const response = await LocationsService.downloadLocationsData(query);
      const contentType = response.headers['content-type'];

      if (response.status === 200 && contentType.includes('text/csv')) {
        // ✅ CSV is ready → download it
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);

        const timestamp = new Date().toLocaleString('en-GB').replace(/[/,: ]/g, '-');
        const fileName = `locations_${timestamp}.csv`;

        link.download = fileName;
        link.click();

        setTimeout(() => {
          notify({
            type: 'success',
            message: 'File downloaded successfully.'
          });
        }, 50);
      } else if (response.status === 202 && contentType.includes('application/json')) {
        notify({
          type: 'success',
          message: 'Your file is being prepared. You will receive an email.'
        });
      } else {
        notify({
          type: 'error',
          message: 'Unexpected response while downloading the file.'
        });
      }
    } catch (error) {
      console.error('Failed to download file:', error);
      notify({
        type: 'error',
        message: 'Something went wrong while downloading the file.'
      });
    }
  };
  // Function to fetch location data
  const fetchLocationsData = async query => {
    let output = {};
    try {
      if(query._isActive && query._isActive.includes('true') && query._isActive.includes('false')){
        delete query._isActive
      } else {
        // ths condition in this way because if query._isActive comes as undefined also 
        // we are setting it as a true which is our default value of _isActive filter
        query._isActive = (query._isActive && query._isActive.includes('false')) ? false : true
      }
      if(query._isVerified && query._isVerified.includes('true') && query._isVerified.includes('false')){
        delete query._isVerified
      } else if (query._isVerified){
        // ths condition in this way because if query._isVerified comes as undefined also 
        // we are setting it as a true which is our default value of _isVerified filter
        query._isVerified = (query._isVerified.includes('false')) ? false : true
      }
      const response = await LocationsService.getLocationsData(query);
      output.data = []
      response.data.forEach(response => {
        output.data.push({
          id : response.id,
          placeName: response.placeName,
          locality: response.locality,
          zipCode: response.zipcode,
          state: response.stateDetails.name,
          latitude: response.lat,
          longitude: response.long,
          isActive: response.isActive,
          isVerified: response.verified,
          type: response.type,
          locode: response.locode,
          unlocode: response.unlocode,
          code: response.code,
          city: response.cityDetails.name,
          country: response.countryDetails.name,
          createdAt: response.createdAt,
          updatedAt: response.updatedAt,
          applicationNamespace: response.applicationNamespace,
          comment: response.comment,
          iataCode: response.iataCode
        })
      })
      if (response.headers.hasOwnProperty('x-total-count')) {
        output['x-total-count'] = parseInt(response.headers['x-total-count']);
      }
    } catch (error) {
      notify({
        type: 'error',
        message: 'Internal Server Error'
      });
    }
    return output;
  };

  const locationsFilterConfig = [
    {
      name: 'country',
      label: 'Country',
      type: 'select',
      isAutocomplete: true,
      options: countries,
      filterChange: handleCountryFilterChange
    },
    {
      name: 'country_code',
      label: 'Country Code',
      isAutocomplete: true,
      type: 'select',
      options: countryCodes,
      filterChange: handleCountryCodeFilterChange
    },
    
    {
      name: 'state',
      label: 'State',
      isAutocomplete: true,
      type: 'select',
      options: states,
      filterChange: handleStateFilterChange
    },
    
    {
      name: 'state_code',
      label: 'State Code',
      isAutocomplete: true,
      type: 'select',
      options: stateCodes,
      filterChange: handleStateCodeFilterChange
    },
    {
      name: 'city',
      label: 'City',
      isAutocomplete: true,
      type: 'select',
      options: cities,
      filterChange: handleCityFilterChange
    },
    {
      name: 'unlocode',
      label: 'Unlocode',
      type: 'text',
      filterChange: handleUnlocodeFilterChange
    },
    {
      name: 'type',
      label: 'Type',
      type: 'select',
      multiselect: true,
      options: locationTypes,
      filterChange: handleTypeFilterChange
    },
    {
      name: 'is_active',
      label: 'Active',
      type: 'select',
      multiselect: true,
      options: [
        { value: 'true', label: 'true' },
        { value: 'false', label: 'false' }
      ],
      filterChange: handleActiveFilterChange
    },
    {
      name: 'is_verified',
      label: 'Verified',
      type: 'select',
      multiselect: true,
      options: [
        { value: 'true', label: 'true' },
        { value: 'false', label: 'false' }
      ],
      filterChange: handleVerifiedFilterChange
    },
    {
      name: 'application_namespace',
      label: 'Application Namespace',
      type: 'select',
      options: applicationNamespaces,
      filterChange: handleApplicationNamespaceFilterChange
    }
  ];

  const renderLocationsFilters = () => {
    return locationsFilterConfig.map(filter => {
      const options = filter.options || [];
      const isCountrySelected =
        !!locationsFilterValues.country_code || !!locationsFilterValues.country;
      const isStateSelected =
        !!locationsFilterValues.state_code || !!locationsFilterValues.state;

      // Determine if the current filter should be disabled
      const isDisabled =
        ((filter.name === 'state' || filter.name === 'state_code' || filter.name === 'city') && !isCountrySelected) || (filter.name === 'city' &&
        !isStateSelected) || (filter.name === 'type' && !locationsFilterValues.application_namespace);
        
      const isMultiSelectFilter = filter.multiselect; // Check if it's the 'type' filter
      return (<Grid item xs={4} key={filter.name}>
        <FormControl fullWidth>
          <InputLabel>{filter.isAutocomplete || filter.type == 'text' ? '' : filter.label}</InputLabel>
          
          {/* Check if it's a text input filter */}
          {filter.type === 'text' ? (
            <TextField
              variant="standard"
              label={filter.label}
              value={locationsFilterValues[filter.name] || ''}
              onChange={(event) => filter.filterChange({
                target: {
                  name: filter.name,
                  value: event.target.value,
                },
              })}
            />
          ) : filter.isAutocomplete ? (
            <Autocomplete
              multiple={isMultiSelectFilter} // Enable multiple selection
              options={options.map(option => option.value || option.name || option)}
              value={locationsFilterValues[filter.name] || []}
              disabled={isDisabled}
              onChange={(event, newValue) => {
                // Update the state for autocomplete
                filter.filterChange({
                  target: {
                    name: filter.name,
                    value: newValue,
                  },
                });
              }}
              disableClearable
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label={filter.label} 
                  variant="standard"
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option}>
                  {options.find(o => o.value === option)?.label || option}
                </li>
              )}
            />
          ) : (
            <Select
              name={filter.name}
              value={locationsFilterValues[filter.name]}
              onChange={isMultiSelectFilter ? null : filter.filterChange}
              disabled={isDisabled}
              multiple={isMultiSelectFilter} // Enable multiple selection for type filter
              renderValue={(selected) =>
                Array.isArray(selected) ? selected.join(', ') : selected
              }
            >
              {options.map(option => (
                <MenuItem
                  key={option.value || option.name || option}
                  value={option.value || option.name || option}
                >
                  {isMultiSelectFilter ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={(locationsFilterValues[filter.name] || []).includes(option.value || option.name || option)}
                          onChange={(event) => {
                            const currentValues = locationsFilterValues[filter.name] || [];
                            const newValue = event.target.value;
      
                            // Add or remove the value from the list
                            const updatedValues = event.target.checked
                              ? [...currentValues, newValue]
                              : currentValues.filter(value => value !== newValue);
      
                            // Update the state
                            filter.filterChange({
                              target: {
                                name: filter.name,
                                value: updatedValues,
                              },
                            });
                          }}
                          value={option.value || option.name || option}
                        />
                      }
                      label={option.label || option.name || option}
                    />
                  ) : (
                    option.label || option.name || option
                  )}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </Grid>
      );
    });
  };

  const RenderLocationsFiltersPreview = ({handleClearFilters }) => {
    let filters = {}

    if(locationsFilterValues.application_namespace){
      filters['Application Namespace'] = locationsFilterValues.application_namespace
    }
    if(locationsFilterValues.type != ''){
      filters.Type = locationsFilterValues.type
    }
    if(locationsFilterValues.unlocode && locationsFilterValues.unlocode.length){
      filters.Unlocode = locationsFilterValues.unlocode
    }
    if(locationsFilterValues.is_active && !(locationsFilterValues.is_active.includes('true') && locationsFilterValues.is_active.includes('false'))){
      filters['Active']  = locationsFilterValues.is_active
    }
    if(locationsFilterValues.is_verified && !(locationsFilterValues.is_verified.includes('true') && locationsFilterValues.is_verified.includes('false'))){
      filters['Verified']  = locationsFilterValues.is_verified
    }
    if(locationsFilterValues.country){
      filters.Country = locationsFilterValues.country
    }
    if(locationsFilterValues.state){
      filters.State = locationsFilterValues.state
    }
    if(locationsFilterValues.city){
      filters.City = locationsFilterValues.city
    }

    return (<div
      style={{
        marginBottom: '10px',
        padding: '5px',
        backgroundColor: '#f9f9f9',
        border: '1px solid #ddd',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="subtitle2"
            style={{
              display: 'inline-block',
              fontWeight: 600,
              marginRight: '10px',
              marginLeft: '10px'
            }}
          >
            Filters :
          </Typography>
          <span style={{ display: 'flexible' }}>
            {Object.entries(filters).map(([key, value], index) => (
              <span
                key={key}
                style={{
                  fontSize: '13px',
                  padding: '3px 10px',
                  backgroundColor: '#f9f9f9',
                  marginRight: index !== Object.entries(filters).length - 1 ? '5px' : '0',
                }}
              >
                {`${key} : ${value}`}
              </span>
            ))}
          </span>
        </div>
        <div style={{ display: 'flex', gap: '8px', marginRight: '10px' }}>
          <Button
            size="small"
            variant="outlined"
            onClick={handleClearFilters}
            style={{ fontSize: '12px', padding: '2px 8px' }}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>)
  };

  return {
    locationsFilterValues,
    setLocationsFilterValues,
    handleLocationsFilterClear,
    getLocationFilters,
    getCountriesData,
    getStatesData,
    getCitiesData,
    fetchLocationsData,
    downloadLocationsData,
    backdrop,
    setBackdrop,
    locationsFilterConfig,
    renderLocationsFilters,
    RenderLocationsFiltersPreview
  };
};
